import { useNavigation, useRoute } from "@react-navigation/native";
import ListItem from "components/atoms/ListItem";
import HStack from "components/atoms/stack/HStack";
import ThemedBlock from "components/atoms/ThemedBlock";
import ThemedLayout, { createRefreshControl } from "components/atoms/ThemedLayout";
import ThemedList from "components/atoms/ThemedList";
import ThemedLoader from 'components/atoms/ThemedLoader';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import TimeslotIcon from "components/molecules/TimeslotIcon";
import FooterBar from 'components/organisms/FooterBar';
import _ from "lodash";
import { AppRoutes } from "navigations/app-routes";
import { useMemo, useRef } from "react";
import { StyleSheet, View } from "react-native";
import { useSelector } from "react-redux";
import { dataConstants } from "services/redux/data/constants";
import Button from "theme/Button";
import FetchCredits from "utils/fetch/FetchCredits";
import useRouteParameters from "utils/hooks/use-route-parameters";
import useFetch from "utils/hooks/useFetch";
import i18n from "utils/i18n";
import Translate from "utils/translate";

const HomeMoreCreditsItemViewScene = () => {
	
	const navigation = useNavigation();
	const route = useRoute();
	const _routeParameters = useRouteParameters( route );

	const timeslotKindGuid = _routeParameters?.timeslot_kind_guid || null;
	
	const _timeslotKinds = useSelector( state => {
		return state.data[dataConstants.TIMESLOT_KINDS];
	} );

	const { data, loading } = useFetch( FetchCredits.fetchAll );

	const layoutRef = useRef( undefined )

	const onPressBuy = () => {
		navigation.navigate( AppRoutes.MORE_CREDITS_BUY, {
			timeslot_kind_guid: timeslotKindGuid,
		} );
	}

	const onPressView = ( item ) => {
		navigation.navigate( AppRoutes.MORE_CREDITS_VIEW, {
			credit: item?.guid,
		});
	}

	const renderItem = ({ item, index }) => {

		const timeslotKind = _.find( _timeslotKinds, { guid: item?.timeslot_kind?.guid } )
		const timeslotKindTitle = Translate.field( timeslotKind, 'title' )

		let subtitle = i18n.t('page.credits.item.status.unused' );
		if( item.status === 'used' ) {
			subtitle = i18n.t('page.credits.item.status.used', { datetime: item.code_used_at });
		}

		return (
			<ListItem
				title={ i18n.t( 'page.credits.item.name', { amount: item.amount, timeslotKind: timeslotKindTitle } ) }
				subtitle={ subtitle }
				accessoryLeft={(
					<View
						style={ styles.iconContainer }>

						<TimeslotIcon
							style={ styles.iconInner }
							timeslot={{
								kind: timeslotKind.kind,
								sub_kind: timeslotKind.sub_kind,
							}}
						/>
					</View>
				)}
				accessoryRight={(
					<HStack>
						<Button onPress={ onPressView.bind( this, item ) }>
							{ i18n.t( 'buttons.view' ) }
						</Button>
					</HStack>
				)}
			/>
		)
	}

	return (
		<ThemedSafeAreaComponentTop 
			top={false}>
			
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				showBackButton
				enableFooterBar={ true }
				title={ i18n.t( 'titles.credits' ) }
				scrollViewProps={{
					...createRefreshControl({
						// onRefresh: reloadMessages.bind( this )
					})
				}}>

				{ loading && (
					<ThemedLoader text={ i18n.t( 'basic.loading' ) } />
				)}

				<ThemedBlock shadow>
					<ThemedList
						data={ data }
						renderItem={ renderItem.bind( this ) }
						scrollEnabled={ false }
					/>
				</ThemedBlock>
			</ThemedLayout>

			{ !loading && (
				<FooterBar
					buttons={(
						<Button
							onPress={ onPressBuy }>

							{ i18n.t( 'page.credits.buy' ) }
						</Button>
					)}
					onHeightCallback={ layoutRef.current?.setFooterHeight }
				/>
			)}
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	iconContainer: {
		width: 40,
		height: 40,
	},
	iconInner: {
		transform: [ {
			scale: 0.6
		} ],
	}
})

export default HomeMoreCreditsItemViewScene;
